<template>
  <div 
    id="app"
    :class="classes">

    <!-- Loading -->
    <transitions-fade>
      <section
        v-if="isLoading"
        ref="apploader"
        class="apploader"
        >
        <div class="apploader__body">
          <div
            v-if="!isErrored" 
            class="apploader__loader">
            <div class="apploader__bara"></div>
            <div class="apploader__barb"></div>
            <div class="apploader__barc"></div>
            <div class="apploader__bard"></div>
            <div class="apploader__bare"></div>
          </div>

          <!-- Loading Error -->
          <div
            v-if="isErrored" 
            class="apploader__report">
            <p>An error occured while loading the application.</p>
            <p>If the error persists send an email to info@infinity-mobile.io</p>
          </div>
        </div>

        <footer class="apploader__footer">
          <p>{{ label }}</p>
        </footer>
      </section>
    </transitions-fade>

    <!-- Application -->
    <template v-if="status == 3">
      <!-- Header -->
      <nav-header />
      <nav-burger />

      <!-- Content -->
      <router-view :key="$route.path" />

      <!-- Footer -->
      <nav-footer />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import NavBurger from '@/components/navigations/burger'
import NavHeader from '@/components/navigations/header'
import NavFooter from '@/components/navigations/footer'

export default {
  name: "SaylOrderAtTable",

  components: {
    NavBurger,
    NavHeader,
    NavFooter,
  },

  computed: {
    ...mapState({
      states: state => state.bootstrap.states,
      status: state => state.bootstrap.status,
      confirm: bootstrap => state.bootstrap.confirm,
    }),

    isLoading(){
      return [this.states.APPLICATION_INIT, this.states.APPLICATION_AUTH, this.states.APPLICATION_MODULES].includes(this.status);
      // return true;
    },

    isErrored(){
      return this.modulesErrors && this.modulesErrors.length > 0
    },

    label(){
      let ret = 'Ready';

      if (this.status === this.states.APPLICATION_INIT){
        ret = 'Initializing the application';
      }

      if (this.status === this.states.APPLICATION_AUTH){
        ret = 'Getting to know you';
      }

      if (this.status === this.states.APPLICATION_MODULES){
        ret = 'Tailoring the perspective'
      }

      return ret;
    },

    classes(){
      return {
        '-is-loading': this.isLoading,
        '-is-active': !this.isLoading
      }
    }
  },
}
</script>
